import React from 'react';
import PropTypes from 'prop-types';
import Label from '../type/Label';
import { Typography } from '@mui/material';

function CustomText (props)  {
        if(props.variant){
        return(
            <Typography className={props.className} variant={props.variant}>{props.id? <Label id={props.id} />: props.children}</Typography>
        );
    }
   if(!props.variant) {
       if(props.id === 'benefitsText'){
      return (<h1 className={props.className} id={props.id}>{props.id? <Label id={props.id} />: props.children}</h1>);
       }
    return ( (props.id === 'benefitsOverviewText' || props.id === 'whatsCoveredTitle' ||props.id === 'extraBenefitsTitle' || props.id === 'CoveredMembersText' || props.id === 'PriorAuthorizationsText') ?
            <h2 className={props.className} id={props.id}>{props.id? <Label id={props.id} />: props.children}</h2>
       : <p className={props.className} id={props.id}>{props.id? <Label id={props.id} />: props.children}</p>
    );
}
}
CustomText.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array,PropTypes.string]),
    variant: PropTypes.string
};

export default CustomText;
